import RadioButton from "components/RadioButton";
import { Text } from "components/Text/Text.component";
import { RequiredIcon } from "components/TextInput/TextInput.styled";
import { FC } from "react";
import { WithStyle } from "utils/WithStyle";
import { Fieldset, Wrapper } from "./RadioGroup.styled";
import { RadioGroupProps, RadioOption } from "./types";

const Component: FC<RadioGroupProps> = ({
    label,
    options,
    value,
    onChange,
    labelColor,
    columns,
    selectedLabelColor,
    required,
    alignment,
    ...rest
}) => {
    function renderRadioOptions() {
        return options.map(
            (
                { label, disabled, value: OptionValue }: RadioOption,
                index
            ) => {
                const shortenedOptionLabel = label.replace(/\s+/g, "");
                const optionId = `radio-option-${shortenedOptionLabel}`;

                return (
                    <RadioButton
                        value={OptionValue}
                        label={label || ""}
                        checked={OptionValue === value}
                        id={optionId}
                        disabled={disabled}
                        defaultChecked={index === 0}
                        onChange={onChange}
                        labelColor={
                            OptionValue === value
                                ? selectedLabelColor
                                : labelColor
                        }
                        required={required}
                        {...rest}
                    />
                );
            }
        );
    }
    return (
        <Fieldset>
            <Text as="label" variant="label" color={labelColor}>
                {label} {required && <RequiredIcon>*</RequiredIcon>}
            </Text>
            <Wrapper columns={columns}>{renderRadioOptions()}</Wrapper>
        </Fieldset>
    );
};
export const RadioGroup: FC<RadioGroupProps> & WithStyle = Object.assign(
    Component,
    {
        Style: Fieldset,
    }
);
